import { produce } from "immer";
import { StatusMessage, Category } from "./StatusMessage";
import { StatusActions } from "./action";

interface State 
{
    statusMessages: StatusMessage[];
}

const initialState: State =
{
    statusMessages: []
};

const reducer = (state = initialState, action: StatusActions) => produce(state, state => 
{
    if (action.type === "STATUS_ADD")
    {
        const { status } = action;
        const statusmessage = state.statusMessages.find(x => x.id === status.id);
        if (statusmessage)
        {
            statusmessage.message = status.message;
            statusmessage.severity = status.severity;
        }
        else
        {
            state.statusMessages.push(status);
        }
        return;
    }

    if (action.type === "STATUS_DISMISS")
    {
        const { id } = action;
        state.statusMessages = state.statusMessages.filter(message => message.id !== id);
        return;
    }
});

export const getStatusMessages = (state: State, category?: Category) =>
    (category === undefined) 
        ? state.statusMessages
        : state.statusMessages.filter(message => message.category === category);

export default reducer;


// WEBPACK FOOTER //
// ./src/state/ui/index.ts